import Box from '@repo/ui/box'
import { DocumentIcon } from '@repo/ui/icons'
import { useState } from 'react'

import UserNavBar from '../../../components/elements/nav-bar'
import EndOfJourneyScanItemsTable from '../../../components/pages/end-of-journey-scans/end-of-journey-scan-items-table'
import EndOfJourneyScanReadingBanner from '../../../components/pages/end-of-journey-scans/end-of-journey-scan-reading-banner'
import EndOfJourneyScanUpload from '../../../components/pages/end-of-journey-scans/end-of-journey-scan-upload'
import useTranslate from '../../../lib/hooks/use-translate'
import { EndOfJourneyScanReadingStatus } from '../../../lib/types/models/end-of-journey-scan/end-of-journey-scan'

const EndOfStayQuestionnairesProcessingPage = () => {
  const { t } = useTranslate()
  // Sent by the backend with the questionnaires list (kept fresh by its polling)
  const [readingStatus, setReadingStatus] = useState<EndOfJourneyScanReadingStatus>()

  return (
    <div className="flex flex-col gap-4">
      <UserNavBar title={t('end.of.journey.scans.page.title')} icon={DocumentIcon} />
      <EndOfJourneyScanReadingBanner readingStatus={readingStatus} />
      <Box>
        <h2 className="font-semibold mb-4">{t('end.of.journey.scans.page.upload.title')}</h2>
        <EndOfJourneyScanUpload />
      </Box>
      <Box>
        <h2 className="font-semibold mb-4">{t('end.of.journey.scans.page.list.title')}</h2>
        <EndOfJourneyScanItemsTable onReadingStatusChange={setReadingStatus} />
      </Box>
    </div>
  )
}

export default EndOfStayQuestionnairesProcessingPage
